<div class="gt-routes-list-containerss ">
    <div class="form-style gt-flex-dir-col">
        <div *ngIf="articleClearance != null" class="dx-fieldset">
            <div class="dx-field">
                <div class="dx-field-label" i18n="@@articelClearance"> Article Clearance </div>
                <div class="dx-field-value">
                    <dx-radio-group [items]="articleClearance" [(value)]="selectedClearance" displayExpr="title"
                        (onValueChanged)="saveChangesClearance($event)">
                    </dx-radio-group>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" i18n="@@automaticNumbering"> Automatic Numbering </div>
                <div class="dx-field-value">
                    <dx-switch class="switch gt-switch" [value]="autoNumbering.value"
                        (onValueChanged)="saveChangesAutoNumbering($event)"></dx-switch>
                </div>
            </div>
        </div>
    </div>
</div>
<dx-toast [visible]="toastVisible" [type]="type" message="{{message}}" position="bottom center" width="fit-content">
</dx-toast>